module.exports = __webpack_public_path__ + "static/media/stats.522c9335.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/stats.svg
// module id = 1701
// module chunks = 0